import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface MicroSiteLinkButtonProps {
  resourceAsset: string | undefined
  showHint: boolean
}

export const MicroSiteLinkButton = ({ resourceAsset, showHint }: MicroSiteLinkButtonProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'engagementResourcesPage' })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <Button
        data-testid="engagement-resources-button"
        variant="contained"
        disabled={!resourceAsset}
        {...(resourceAsset
          ? { href: resourceAsset, target: '_blank', rel: 'noopener noreferrer' }
          : {})}
        sx={{
          '&:hover': { backgroundColor: '#3a3939' },
        }}
      >
        {t('freeResources.button')}
      </Button>
      {showHint && (
        <Box
          data-testid="engagement-resources-button-hint"
          sx={{ display: 'flex', alignItems: 'center', gap: '4px', color: 'error.main' }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 14 }} />
          <Typography variant="caption">{t('freeResources.buttonDisabledHint')}</Typography>
        </Box>
      )}
    </Box>
  )
}
